import type { KeyboardEvent } from "react";

export interface RowKeys {
  readonly onActivate?: (() => void) | undefined;
  readonly onPick?: (() => void) | undefined;
}

export const ROW_SELECTOR = "tr[data-row]";

export function moveRowFocus(row: HTMLElement, step: 1 | -1): void {
  const rows = [...(row.closest("tbody")?.querySelectorAll<HTMLElement>(ROW_SELECTOR) ?? [])];
  rows[rows.indexOf(row) + step]?.focus();
}

export function useRowKeyboardNav({ onActivate, onPick }: RowKeys) {
  return (event: KeyboardEvent<HTMLElement>) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === "Enter" && onActivate) {
      event.preventDefault();
      onActivate();
    } else if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      moveRowFocus(event.currentTarget, event.key === "ArrowDown" ? 1 : -1);
    } else if (event.key === " " && onPick) {
      event.preventDefault();
      onPick();
    }
  };
}
